export const numberToWords = (num: number) => {
  if (num === 0) {
    return 'Ноль сома';
  }

  const ones = ['', 'один', 'два', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'];
  const onesThousand = [
    '',
    'одна',
    'две',
    'три',
    'четыре',
    'пять',
    'шесть',
    'семь',
    'восемь',
    'девять',
  ];

  const teens = [
    'десять',
    'одиннадцать',
    'двенадцать',
    'тринадцать',
    'четырнадцать',
    'пятнадцать',
    'шестнадцать',
    'семнадцать',
    'восемнадцать',
    'девятнадцать',
  ];

  const tens = [
    '',
    '',
    'двадцать',
    'тридцать',
    'сорок',
    'пятьдесят',
    'шестьдесят',
    'семьдесят',
    'восемьдесят',
    'девяносто',
  ];

  const hundreds = [
    '',
    'сто',
    'двести',
    'триста',
    'четыреста',
    'пятьсот',
    'шестьсот',
    'семьсот',
    'восемьсот',
    'девятьсот',
  ];

  const thousandsWords = ['тысяча', 'тысячи', 'тысяч'];
  const millionsWords = ['миллион', 'миллиона', 'миллионов'];

  const getWordForm = (num: number, forms: string[]) => {
    if (num % 10 === 1 && num % 100 !== 11) {
      return forms[0];
    }

    if ([2, 3, 4].includes(num % 10) && ![12, 13, 14].includes(num % 100)) {
      return forms[1];
    }

    return forms[2];
  };

  const convertLessThanThousand = (num: number, isThousand = false) => {
    let words = '';

    if (num >= 100) {
      words += hundreds[Math.floor(num / 100)] + ' ';
      num %= 100;
    }

    if (num >= 10 && num < 20) {
      words += teens[num - 10] + ' ';

      return words.trim();
    } else if (num >= 20) {
      words += tens[Math.floor(num / 10)] + ' ';
      num %= 10;
    }

    if (num > 0) {
      words += (isThousand ? onesThousand[num] : ones[num]) + ' ';
    }

    return words.trim();
  };

  const integerPart = Math.floor(num);
  const fractionPart = Math.round((num - integerPart) * 100);

  let words = '';

  if (integerPart >= 1_000_000) {
    const millionsPart = Math.floor(integerPart / 1_000_000);

    words +=
      convertLessThanThousand(millionsPart) + ' ' + getWordForm(millionsPart, millionsWords) + ' ';
  }

  if (integerPart >= 1_000) {
    const thousandsPart = Math.floor((integerPart % 1_000_000) / 1_000);

    words +=
      convertLessThanThousand(thousandsPart, true) +
      ' ' +
      getWordForm(thousandsPart, thousandsWords) +
      ' ';
  }

  const lastPart = integerPart % 1_000;

  if (lastPart > 0 || integerPart === 0) {
    words += convertLessThanThousand(lastPart) + ' ';
  }

  words = words.trim();
  words = words.charAt(0).toUpperCase() + words.slice(1) + ' сома';

  if (fractionPart > 0) {
    words += ' ' + convertLessThanThousand(fractionPart) + ' тыйына';
  }

  return words;
};
